import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare `/details/$id` → the Manage tab (Pattern B index redirect — never `<Navigate>`). */
export const Route = createFileRoute('/console/$orgId/compliance/coi/details/$id/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/compliance/coi/details/$id/manage',
            params,
            replace: true,
        });
    },
});
